var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 67.9375 119.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 119.688,
    opacity: 0,
    width: 67.9375,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 85.5C35.3125 85.5 37.3125 82.5 37.3125 78.5C37.3125 77.8125 37.3125 77.0625 37.3125 76.375C37.4375 68.125 40.375 64.6875 50.375 57.8125C61.125 50.5625 67.9375 42.1875 67.9375 30.125C67.9375 11.375 52.6875 0.625 33.6875 0.625C19.5625 0.625 7.1875 7.3125 1.875 19.375C0.5625 22.3125 0 25.1875 0 27.5625C0 31.125 2.0625 33.625 5.875 33.625C9.0625 33.625 11.1875 31.75 12.125 28.6875C15.3125 16.8125 23.1875 12.3125 33.25 12.3125C45.4375 12.3125 55 19.1875 55 30.0625C55 39 49.4375 44 41.4375 49.625C31.625 56.4375 24.4375 63.75 24.4375 74.75C24.4375 76.0625 24.4375 77.375 24.4375 78.6875C24.4375 82.6875 26.625 85.5 30.9375 85.5ZM30.9375 119.688C35.9375 119.688 39.875 115.688 39.875 110.812C39.875 105.875 35.9375 101.938 30.9375 101.938C26.0625 101.938 22.0625 105.875 22.0625 110.812C22.0625 115.688 26.0625 119.688 30.9375 119.688Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/questionmark.d16db2dd939fc496c8813ebb4539e38d.svg";
export { ForwardRef as ReactComponent };